import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Hyperlink from 'components/Hyperlink/Hyperlink';
import icons from 'components/SocialMediaIcons';
import ProfileStore from 'stores/ProfileStore';
import { generateID } from 'utils/helpers';

import styles from './MobileProfileSocialMedia.css';


const socialIcons = {
  facebook: icons.Facebook,
  instagram: icons.Instagram,
  snapchat: icons.Snapchat,
  tempted: icons.Tempted,
  tiktok: icons.Tiktok,
  tumblr: icons.Tumblr,
  twitter: icons.Twitter,
  telegram: icons.Telegram,
};

function MobileProfileSocialMedia(props) {
  const { profileInfo: { socialNetworks } } = ProfileStore;
  const { margin } = props;

  const IDS = {
    prefix: 'mHj213Lk',
    element: 'profileSocialMedia',
    twitter: 'twitter',
    snapchat: 'snapchat',
    instagram: 'instagram',
    tumblr: 'tumblr',
    facebook: 'facebook',
    tempted: 'tempted',
    telegram: 'telegram',
  };
  const makeId = generateID(IDS.prefix, IDS.element);

  const containerClasses = classNames({
    [styles.container]: true,
    [styles.margin]: margin,
  });

  return (
    <div className={containerClasses}>
      <div className={styles.socialIconsContainer}>
        {socialNetworks &&
          Object
            .keys(socialNetworks)
            .map((connectedNetworkKey) => {
              const SocialMediaIcon = socialIcons[connectedNetworkKey];

              return (
                <Hyperlink
                  key={connectedNetworkKey}
                  className={styles.socialIconContainer}
                  href={socialNetworks[connectedNetworkKey]}
                  id={makeId(connectedNetworkKey)}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <SocialMediaIcon className={styles.socialIcon} />
                </Hyperlink>
              );
            })
        }
      </div>
    </div>
  );
}

MobileProfileSocialMedia.propTypes = { margin: PropTypes.bool };

MobileProfileSocialMedia.defaultProps = { margin: false };

export default observer(MobileProfileSocialMedia);
